// extracted by mini-css-extract-plugin
module.exports = {"container":"DebtFormSubtitle_container__tMxOF"};